export default __webpack_public_path__ + "static/recent-postcard-3-0c925b660fe5749f57405861f3d62dcc.jpeg";